import { useLocation, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, InputGroup, Row, Table } from "react-bootstrap";
import ReactSelect from "../../Components/ReactSelect";
import PhoneInput from "../../Components/PhoneInput/PhoneInput";
import useApi from "../../Hooks/useApi";
import * as api from "../../api/getapi";
import * as postapi from "../../api/postapi";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faCreditCard, faMinus, faMoneyBill1, faPlus } from "@fortawesome/free-solid-svg-icons";
import { isValidUrl } from "../../Utilities/url";
import style from "./DeliverForYouCreateOrder.module.css";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import SearchableSelect from "../../Components/SearchableSelect";
import LoaderOverlay from "../../Components/Loader/loaderOverlay";

function LegacyDeliverForYouCreateOrder() {
  const { user } = useSelector((state) => state.auth);

  const [error, setError] = useState("");
  const [formValidated, setFormValidated] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  /* cutomer details */
  const [customerInput, setCustomerInput] = useState({
    name: "",
    phone: "",
    email: "",
    address: "",
    postalCode: "",
    city: null,
    province: null,
  });

  /* END of cutomer details */

  /* city dropdown */
  const dropdownProvince = useApi(api.getProvinces, { hasCatchError: true });
  const [provinceOptionsData, setProvinceOptionsData] = useState([]);
  const [provinceOptions, setProvinceOptions] = useState([]);
  const [isProvinceLoading, setIsProvinceLoading] = useState(false);
  const getProvinces = async () => {
    setIsProvinceLoading(true);
    dropdownProvince
      .request()
      .then((res) => {
        const getData = res?.data?.map((cat) => ({
          value: cat.province_id,
          label: cat.province_name,
        }));
        setIsProvinceLoading(false);
        setProvinceOptions(getData);
        setProvinceOptionsData(getData);
      })
      .catch((err) => {
        setIsProvinceLoading(false);
        console.error("err" + err);
      });
  };
  useEffect(() => {
    getProvinces();
  }, []);
  const handleProvinceChange = (e) => {
    setCustomerInput((prev) => ({ ...prev, province: e, city: null }));
    setCityOptions([]);
  };

  const dropdownCity = useApi(api.getCities, { hasCatchError: true });
  // const dropdownCity = useApi(api.fetchActiveDeliveryCities, { hasCatchError: true });
  const [cityOptions, setCityOptions] = useState([]);
  const [deliveryCharges, setDeliveryCharges] = useState(0);
  const [loadingDeliveryCharges, setLoadingDeliveryCharges] = useState(false);
  const [isCitiesLoading, setIsCitiesLoading] = useState(false);

  const getCities = async (id) => {
    setIsCitiesLoading(true);
    dropdownCity
      .request(id)
      .then((res) => {
        const getData = res?.data?.map((cat) => ({
          value: cat.city_id,
          label: cat.city_name,
        }));
        setIsCitiesLoading(false);
        setCityOptions(getData);
      })
      .catch((err) => {
        setIsCitiesLoading(false);
        console.error("err" + err);
      });
  };

  useEffect(() => {
    if (customerInput?.province?.value) {
      getCities(customerInput?.province?.value);
    }
  }, [customerInput?.province]);

  const handleCityChange = (e) => {
    setCustomerInput((prev) => ({ ...prev, city: e }));
  };
  /* END of city dropdown */

  /* Fetch Listing states and handlers */

  const [listingFetchInput, setListingFetchInput] = useState("");
  const [listingFetchInputID, setListingFetchInputID] = useState("");
  const [listingFetchInputError, setListingFetchInputError] = useState("");
  const [fetchedListing, setFetchedListing] = useState(null);
  const fetchListingForOrder = useApi(api.fetchOrderListing, { hasCatchError: true });

  const [orderQuantity, setOrderQuantity] = useState(1);

  const handleListingFetchInput = (e) => {
    setListingFetchInputError("");
    setListingFetchInput(e.target.value);

    if (!isNaN(e.target.value)) {
      // ID
      setListingFetchInputID(e.target.value);
    } else {
      if (isValidUrl(e.target.value)) {
        const urlArray = e.target.value.split("-");
        const id = urlArray[urlArray.length - 1];
        if (!isNaN(id)) {
          setListingFetchInputID(id);
        } else {
          setListingFetchInputError("Please Enter a valid Link");
        }
      } else {
        setListingFetchInputError("Please Enter Listing ID or a valid Link");
      }
    }
  };
  const handleFetchListing = async () => {
    try {
      if (listingFetchInputID?.length > 0) {
        const res = await fetchListingForOrder.request(listingFetchInputID);
        setFetchedListing(res?.data?.data);
      } else {
        setListingFetchInputError("Please Enter Listing ID or a valid Link");
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        setListingFetchInputError(error?.response?.data?.message);
      } else {
        setListingFetchInputError(error?.message);
      }
    }
  };

  /* IF we get listing in URL */
  useEffect(() => {
    if (location?.state?.listingData) {
      setFetchedListing(location?.state?.listingData);
    }
  }, [location?.state?.listingData]);

  /* END of Fetch Listing states and handlers */

  /* payment Radio */
  const [paymentType, setPaymentType] = useState("Cash on Delivery");
  const handlePaymentTypeChange = (e) => {
    setPaymentType(e.target.value);
  };
  /* END of payment Radio */

  /* Delivery Type Radio */
  const [deliveryType, setDeliveryType] = useState("Standard Delivery");
  const [customDeliveryCharge, setCustomDeliveryCharge] = useState("");
  const [isCustomDeliveryFocused, setIsCustomDeliveryFocused] = useState(false);
  const handleDeliveryTypeChange = (e) => {
    setDeliveryType(e.target.value);
    if (e.target.value === "Standard Delivery") {
      setCustomDeliveryCharge("");
      setIsCustomDeliveryFocused(false);
    }
  };
  const handleCustomDeliveryChange = (e) => {
    const value = e.target.value;
    if (value === "" || /^\d*\.?\d*$/.test(value)) {
      setCustomDeliveryCharge(value);
    }
  };
  /* END of Delivery Type Radio */

  /* Delivery Charges */
  const deliveryChargesApi = useApi(api.LegacyfetchDeliveryChargesByCityAndCategory, { hasCatchError: true });
  const fetchDeliveryCharges = async ({ city, category, multiplyRate }) => {
    try {
      setLoadingDeliveryCharges(true);
      const res = await deliveryChargesApi.request({ city, category });
      if (res?.data?.data[0]) {
        setDeliveryCharges(+res?.data?.data[0]?.charges * multiplyRate);
        setLoadingDeliveryCharges(false);
      }
    } catch (error) {
      setLoadingDeliveryCharges(false);
      setDeliveryCharges(null);
      console.error(error?.response?.data?.message);
    }
  };

  useEffect(() => {
    let multiplier = 1;
    if (fetchedListing?.city?.city_name !== customerInput?.city?.label) {
      multiplier = 2;
    }
    if (customerInput?.city && fetchedListing?.listing?.category_id) {
      fetchDeliveryCharges({
        // city: customerInput?.city?.label, // it is temporarily not in used until we are using external city api
        city: "lahore",
        category: fetchedListing?.listing?.category_id,
        multiplyRate: multiplier,
      });
    }
  }, [fetchedListing, customerInput?.city]);

  /* END of Delivery Charges */

  /* Handled BY */

  const [orderHandledBy, setOrderHandledBy] = useState(null);

  /* END of Handled BY */

  const [formSubmitting, setFormSubmitting] = useState(false);

  const createOrderAPI = useApi(postapi.LegacycreateD4uOrder, { hasCatchError: true });

  const handleOrderSubmit = async (e) => {
    try {
      e.preventDefault();
      setFormValidated(true);
      setFormSubmitting(true);
      // const form = e.target;
      // console.log(form.checkValidity());

      if (formSubmitting) {
        toast.error(`This order is already in progress wait for the response.`, { position: toast.POSITION.BOTTOM_RIGHT, className: "toastMsg" });

        return;
      }

      if (!fetchedListing) {
        toast.error(`Please select product to proceed the order.`, { position: toast.POSITION.BOTTOM_RIGHT, className: "toastMsg" });
        return;
      }
      if (Object.values(customerInput).some((value) => value === "" || value === null)) {
        toast.error(`Please enter customer information to proceed the order.`, { position: toast.POSITION.BOTTOM_RIGHT, className: "toastMsg" });
        return;
      }

      if (deliveryType === "Standard Delivery") {
        if (loadingDeliveryCharges) {
          toast.error(`Please wait while we fetch delivery charges.`, { position: toast.POSITION.BOTTOM_RIGHT, className: "toastMsg" });
          return;
        }
        if (!deliveryCharges) {
          if (customerInput?.city && fetchedListing?.listing?.category_id) {
            toast.error(`There is no delivery charges saved against ${customerInput?.city?.label}.`, { position: toast.POSITION.BOTTOM_RIGHT, className: "toastMsg" });
          } else {
            toast.error(`Delivery Charges not set.`, { position: toast.POSITION.BOTTOM_RIGHT, className: "toastMsg" });
          }
          return;
        }
      } else if (deliveryType === "Custom Delivery") {
        if (customDeliveryCharge === "" || +customDeliveryCharge < 0) {
          toast.error(`Please enter a valid custom delivery charge.`, { position: toast.POSITION.BOTTOM_RIGHT, className: "toastMsg" });
          return;
        }
      }

      if (!orderHandledBy) {
        toast.error(`Please fill Order handled by field.`, { position: toast.POSITION.BOTTOM_RIGHT, className: "toastMsg" });
        return;
      }

      if (customerInput?.postalCode?.length !== 5) {
        toast.error(`Please enter valid postal code.`, { position: toast.POSITION.BOTTOM_RIGHT, className: "toastMsg" });
        return;
      }
      const data = {
        product_title: fetchedListing?.listing?.listing_title,
        original_price: fetchedListing?.listing?.online_price,
        discount_unit: fetchedListing?.listing?.online_discount_unit,
        discount_value: fetchedListing?.listing?.online_discount,
        trx_method: paymentType === "Debit/Credit Card" ? "Card" : "Cash",
        status: "Pending",
        quantity: orderQuantity,
        price: fetchedListing?.listing?.effective_price,
        total_price: orderQuantity * fetchedListing?.listing?.effective_price + (deliveryType === "Custom Delivery" ? +customDeliveryCharge : deliveryCharges),
        customer_name: customerInput?.name,
        customer_email: customerInput?.email,
        customer_phone: customerInput?.phone,
        customer_address: `${customerInput?.address}, ${customerInput?.city?.value}, ${customerInput?.province?.value}, ${customerInput?.postalCode}`,
        fk_item_id: fetchedListing?.listing?.fk_item_id,
        fk_listing_id: fetchedListing?.listing?.listing_id,
        fk_customer_id: null,
        fk_shop_id: fetchedListing?.shop?.shop_id,
        fk_location_id: fetchedListing?.location?.location_id,
        delivery_charges: deliveryType === "Custom Delivery" ? +customDeliveryCharge : deliveryCharges,
        fk_handler_id: user.user_id,
        order_handled_by: orderHandledBy?.value,
      };

      const res = await createOrderAPI.request(data);
      if (res) {
        toast.success(`Order Created Successfully`, { position: toast.POSITION.BOTTOM_RIGHT, className: "toastMsg" });

        navigate("/delivery-for-you/orders");
      }
    } catch (error) {
      // set error here
      if (error?.response?.data?.message) {
        setError(error?.response?.data?.message);
      } else {
        setError(error?.message);
      }
    } finally {
      setFormSubmitting(false);
    }
  };

  return (
    <>
      <LoaderOverlay loading={formSubmitting} />
      <Container fluid>
        <div className="bg-white">
          <div className="d-flex ps-5 pt-5">
            <Button
              onClick={() => {
                navigate("/delivery-for-you/orders");
              }}
              className=""
              style={{ width: "100px" }}
            >
              Back
            </Button>
          </div>
          <div className="pt-2 p-5 mx-0 mx-lg-5">
            <Form noValidate validated={formValidated} onSubmit={handleOrderSubmit}>
              {error && <div className="text-danger text-center my-1 rounded-1 w-100">*{error}</div>}

              <h3 className="border-bottom pt-3 pb-2">Product</h3>

              {fetchedListing ? (
                <div className="position-relative">
                  <div className="d-flex gap-2">
                    <img style={{ objectFit: "contain" }} className={`${style.itemImg} `} alt={fetchedListing?.listing?.listing_title} src={` ${process.env.REACT_APP_URL_S3}/${fetchedListing?.listing?.img0}`} width={100} height={80} />

                    <div className="d-flex flex-column ">
                      <span>{fetchedListing?.listing?.listing_title}</span>
                      <span>Rs. {fetchedListing?.listing?.effective_price}</span>
                    </div>
                  </div>
                  <div className="d-flex gap-2 w-25 pt-2">
                    <Button
                      className={``}
                      onClick={(e) => {
                        e.preventDefault();
                        setOrderQuantity((prev) => {
                          if (prev > 1) {
                            return prev - 1;
                          } else {
                            return prev;
                          }
                        });
                      }}
                    >
                      <FontAwesomeIcon className="fs-12 " icon={faMinus} />
                    </Button>
                    <Form.Control type="number" className=" p-0  px-0 text-center" min={1} max={fetchedListing?.listing?.listed_quantity} placeholder="1" value={orderQuantity} onChange={(e) => {}} />
                    <Button
                      className={``}
                      onClick={(e) => {
                        e.preventDefault();
                        setOrderQuantity((prev) => {
                          if (prev < fetchedListing?.listing?.listed_quantity) {
                            return prev + 1;
                          } else {
                            return prev;
                          }
                        });
                      }}
                    >
                      <FontAwesomeIcon className="fs-12" icon={faPlus} />
                    </Button>
                  </div>
                  <div className="position-absolute top-0 end-0 cursor-pointer" onClick={() => setFetchedListing(null)}>
                    <FontAwesomeIcon icon={faClose} />
                  </div>
                </div>
              ) : (
                <Form.Group className="mt-1" as={Col} lg="12" md="12" sm="12" controlId="lisitngSearch">
                  <label>
                    Link/Listing ID<span className="text-danger">*</span>
                  </label>
                  <InputGroup className="">
                    <Form.Control placeholder="Enter Listing ID or Link..." value={listingFetchInput} onChange={handleListingFetchInput} />
                    <Button variant="primary" onClick={handleFetchListing}>
                      Fetch
                    </Button>
                  </InputGroup>
                  {listingFetchInputError?.length > 0 && <div className="text-danger text-center mb-1 rounded-1 w-100">*{listingFetchInputError}</div>}
                  {!(listingFetchInputError?.length > 0) && formValidated && <div className="text-danger text-center mb-1 rounded-1 w-100">*Please Select Product</div>}
                </Form.Group>
              )}

              <h3 className="border-bottom pt-3 pb-2">Cutomer Details</h3>
              <Row className="">
                <Form.Group className="mt-1" as={Col} lg="6" md="6" sm="12" controlId="customerName">
                  <label>
                    Name<span className="text-danger">*</span>
                  </label>
                  <Form.Control value={customerInput?.name} type="text" placeholder="i.e. john doe" onChange={(e) => setCustomerInput((prev) => ({ ...prev, name: e.target.value }))} required />
                  <Form.Control.Feedback type="invalid">Please Enter Customer Name</Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mt-1" as={Col} lg="6" md="6" sm="12" controlId="customerEmail">
                  <label>
                    Email<span className="text-danger">*</span>
                  </label>
                  <Form.Control value={customerInput?.email} type="email" maxLength={64} placeholder="i.e. abc@xyz.com" onChange={(e) => setCustomerInput((prev) => ({ ...prev, email: e.target.value }))} required />
                  <Form.Control.Feedback type="invalid">Please Enter Customer Email</Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mt-1" as={Col} lg="12" md="12" sm="12" controlId="customerAddress">
                  <label>
                    Address <span className="text-danger">*</span>
                  </label>
                  <Form.Control value={customerInput?.address} type="text" placeholder="i.e. House no. X Street ABC" onChange={(e) => setCustomerInput((prev) => ({ ...prev, address: e.target.value }))} required />
                  <Form.Control.Feedback type="invalid">Please Enter Customer Address</Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mt-1" as={Col} lg="6" md="6" sm="12" controlId="customerProvince">
                  <label>
                    Province<span className="text-danger">*</span>
                  </label>

                  <SearchableSelect
                    placeholder="Select Province"
                    value={customerInput?.province}
                    searchable={true}
                    options={provinceOptions}
                    isClearable={true}
                    handleChange={handleProvinceChange}
                    onInputChange={(newInput) => {
                      if (!newInput) {
                        setProvinceOptions(provinceOptionsData); // Reset to full dataset when input is empty
                      } else {
                        setProvinceOptions(provinceOptionsData.filter((option) => option.label.toLowerCase().includes(newInput.toLowerCase())));
                      }
                      return newInput;
                    }}
                    isLoading={isProvinceLoading}
                  />

                  <Form.Control className="p-2" name="province" hidden type="text" value={customerInput?.province ? customerInput?.province?.value : null} onChange={() => {}} required />
                  <Form.Control.Feedback type="invalid">* Please Select Province</Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mt-1" as={Col} lg="6" md="6" sm="12" controlId="customerCity">
                  <label>
                    City<span className="text-danger">*</span>
                  </label>

                  <SearchableSelect placeholder="Select City" value={customerInput?.city} searchable={true} options={cityOptions} isClearable={true} handleChange={handleCityChange} disabled={!customerInput?.province} isLoading={isCitiesLoading} />

                  <Form.Control className="p-2" name="city" hidden type="text" value={customerInput?.city ? customerInput?.city?.value : null} onChange={() => {}} required />
                  <Form.Control.Feedback type="invalid">* Please Select City</Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mt-1" as={Col} lg="6" md="6" sm="12" controlId="cutomerPostalCode">
                  <label>
                    Postal Code <span className="text-danger">*</span>
                  </label>
                  <Form.Control
                    value={customerInput?.postalCode}
                    type="text"
                    placeholder="i.e. 54000"
                    maxLength={5}
                    onBeforeInput={(event) => {
                      const input = event.data;
                      if (input && !/[0-9]/.test(input)) {
                        event.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      setCustomerInput((prev) => ({ ...prev, postalCode: e.target.value }));
                    }}
                    onPaste={(e) => {
                      const pasteData = (e.clipboardData || window.clipboardData).getData("text").replace(/[^0-9]/g, "");
                      if (pasteData.length > 5) {
                        setCustomerInput((prev) => ({ ...prev, postalCode: pasteData.slice(0, 5) }));
                      } else {
                        setCustomerInput((prev) => ({ ...prev, postalCode: pasteData }));
                      }
                      e.preventDefault();
                    }}
                    isInvalid={formValidated && customerInput?.postalCode?.length !== 5}
                    required
                  />
                  <Form.Control.Feedback type="invalid">Please Enter 5 digit Postal Code</Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="my-2" as={Col} lg="6" md="6" sm="12" controlId="customerPhoneNumber">
                  <label>
                    Phone Number<span className="text-danger">*</span>
                  </label>
                  <PhoneInput
                    className="p-2"
                    type="number"
                    placeholder="+92-3XX-XXXXXXX"
                    value={customerInput?.phone}
                    onChange={(e) => setCustomerInput((prev) => ({ ...prev, phone: e.target.value }))}
                    pattern="^((\+92)|(0092))-{0,1}\d{3}-{0,1}\d{7}$|^\d{11}$|^\d{4}-\d{7}$"
                    required
                    isInvalid={formValidated && customerInput?.phone?.replaceAll("_", "").length !== 15}
                  />
                  <Form.Control.Feedback type="invalid">* Please Enter Correct Phone Number</Form.Control.Feedback>
                </Form.Group>

                <h3 className="border-bottom pt-3 pb-2">Payment Method</h3>
                <div className={`${style.paymentRadioDiv}`}>
                  <Form.Group className="col d-flex justify-content-around">
                    <div>
                      <Form.Label className="d-flex align-items-center m-3">
                        <Form.Check type="radio" value="Cash on Delivery" onChange={handlePaymentTypeChange} checked={paymentType === "Cash on Delivery"} required name="paymentMethod" isValid={formValidated && paymentType === "Cash on Delivery"} className="me-2" />
                        <div>
                          <FontAwesomeIcon icon={faMoneyBill1} /> Cash on Delivery
                        </div>
                      </Form.Label>
                    </div>
                    <div>
                      <Form.Label className="d-flex align-items-center m-3">
                        <Form.Check type="radio" value="Debit/Credit Card" onChange={handlePaymentTypeChange} checked={paymentType === "Debit/Credit Card"} required name="paymentMethod" isValid={formValidated && paymentType === "Debit/Credit Card"} className="me-2" disabled />
                        <div>
                          <FontAwesomeIcon icon={faCreditCard} /> Debit/Credit Card
                        </div>
                      </Form.Label>
                    </div>
                  </Form.Group>
                </div>
              </Row>

              <h3 className="border-bottom pt-3 pb-2">Delivery Type</h3>
              <div className={`${style.paymentRadioDiv}`}>
                <Form.Group className="col d-flex justify-content-around">
                  <div>
                    <Form.Label className="d-flex align-items-center m-3">
                      <Form.Check type="radio" value="Standard Delivery" onChange={handleDeliveryTypeChange} checked={deliveryType === "Standard Delivery"} required name="deliveryType" className="me-2" />
                      <div>Standard Delivery</div>
                    </Form.Label>
                  </div>
                  <div>
                    <Form.Label className="d-flex align-items-center m-3">
                      <Form.Check type="radio" value="Custom Delivery" onChange={handleDeliveryTypeChange} checked={deliveryType === "Custom Delivery"} required name="deliveryType" className="me-2" />
                      <div>Custom Delivery</div>
                    </Form.Label>
                  </div>
                </Form.Group>
              </div>

              <h3 className="border-bottom pt-3 pb-2">Order Details</h3>
              <Row className="">
                <Col lg="6" md="6" sm="12">
                  <Form.Group className="mt-1" controlId="handledBy">
                    <label>
                      Order Handled By<span className="text-danger">*</span>
                    </label>

                    <SearchableSelect
                      placeholder="Select"
                      searchable={false}
                      value={orderHandledBy}
                      options={[
                        { value: "Support", label: "Support" },
                        { value: "Shop", label: "Shop" },
                        { value: "Delivery Partner", label: "Delivery Partner" },
                      ]}
                      handleChange={(e) => setOrderHandledBy(e)}
                    />

                    <Form.Control className="p-2" name="city" hidden type="text" value={orderHandledBy ? orderHandledBy?.value : null} onChange={() => {}} required />
                    <Form.Control.Feedback type="invalid">* Please Select Handled by detail</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg="6" md="6" sm="12">
                  <Table>
                    <tbody>
                      <tr>
                        <td className="pb-0 border-0">Sub Total</td>
                        <td className="pb-0 text-end border-0">{orderQuantity * (fetchedListing?.listing?.effective_price ?? 0)} PKR</td>
                      </tr>
                      <tr>
                        <td>Shipping</td>
                        <td className="text-end">
                          {deliveryType === "Custom Delivery" ? (
                            isCustomDeliveryFocused ? (
                              <Form.Control
                                type="text"
                                placeholder="Enter amount"
                                value={customDeliveryCharge}
                                onChange={handleCustomDeliveryChange}
                                onBlur={() => setIsCustomDeliveryFocused(false)}
                                autoFocus
                                style={{ width: "150px", display: "inline-block", marginRight: "5px" }}
                              />
                            ) : (
                              <span
                                onClick={() => setIsCustomDeliveryFocused(true)}
                                style={{ cursor: "pointer", textDecoration: "underline" }}
                              >
                                {customDeliveryCharge ? `${customDeliveryCharge} PKR` : "Click to enter amount"}
                              </span>
                            )
                          ) : (
                            <span>{deliveryCharges} PKR</span>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td>Total</td>
                        <td className="text-end">
                          {orderQuantity * (fetchedListing?.listing?.effective_price ?? 0) + (deliveryType === "Custom Delivery" ? (+customDeliveryCharge || 0) : deliveryCharges)} PKR
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </Col>
              </Row>
              <Row className="pt-5">
                <Col className="d-flex justify-content-center">
                  <Button className="w-25" type="submit" disabled={formSubmitting || (deliveryType === "Custom Delivery" && (customDeliveryCharge === "" || +customDeliveryCharge < 0))}>
                    Place Order
                  </Button>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </Container>
    </>
  );
}

export default LegacyDeliverForYouCreateOrder;
